export const formatDateISO = (d) => {
  if (!d) return "—";
  try {
    return new Date(`${d}T12:00:00`).toLocaleDateString("pt-BR", {
      day: "2-digit", month: "short", year: "numeric",
    }).replace(".", "");
  } catch { return d; }
};

export const formatShort = (d) => {
  if (!d) return "—";
  try {
    return new Date(`${d}T12:00:00`).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" }).replace(".", "");
  } catch { return d; }
};

export const daysUntil = (d) => {
  if (!d) return null;
  const t = new Date(`${d}T12:00:00`);
  const now = new Date();
  return Math.ceil((t - now) / (1000 * 60 * 60 * 24));
};

export const statusForDays = (d) => {
  if (d === null || d === undefined) return "regular";
  if (d < 0) return "urgente";
  if (d <= 30) return "urgente";
  if (d <= 90) return "atencao";
  return "regular";
};

export const initials = (n = "") =>
  n.split(" ").filter(Boolean).map(x => x[0]).slice(0, 2).join("").toUpperCase();

export const formatApiError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Ocorreu um erro. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(" · ");
  if (d?.msg) return d.msg;
  return String(d);
};
